<rappider-page-wrapper [titleToolbarConfig]="titleToolbarConfig">
  <section>
    <router-outlet></router-outlet>
  </section>
</rappider-page-wrapper>